import styles from "./orderSuggestionsShowcase.module.css";

interface OrderSuggestionsShowcaseProps {
  lang: "tr" | "en";
}

// Bilingual labels for the decorative order-panel mock. The page's indexed copy
// lives in landingPages.ts; these are supplementary visual labels.
const L = {
  tr: {
    caption: "Sipariş önerisi panelinin örnek görünümü",
    title: "Sipariş önerileri",
    advisory: "TAHMİNİ",
    basis: "Son 8 haftaya göre · %95 doluluğa kadar",
    arrives: "Tanker varışı",
    order: "Sipariş",
    now: "Şimdi",
    atArrival: "Varışta",
    urgent: "ACİL",
    willRunDry: "bitebilir",
  },
  en: {
    caption: "Sample view of the order-suggestions panel",
    title: "Order suggestions",
    advisory: "ESTIMATED",
    basis: "Based on last 8 weeks · fills to 95%",
    arrives: "Tanker arrives",
    order: "Order",
    now: "Now",
    atArrival: "At arrival",
    urgent: "URGENT",
    willRunDry: "will run dry",
  },
};

const TANKS = [
  { name: "T1", fuel: "VP Diesel", color: "#16a34a", now: "6.000 L", arrival: "5.250 L", order: "~14.000 L", urgent: false, dry: false },
  { name: "T3", fuel: "VP95", color: "#dc2626", now: "1.200 L", arrival: "−300 L", order: "~9.500 L", urgent: true, dry: true },
  { name: "T4", fuel: "AdBlue", color: "#0891b2", now: "640 L", arrival: "590 L", order: "~250 L", urgent: false, dry: false },
];

/**
 * A static, crawler-safe CSS mock of the order-suggestions panel, used as the
 * "screenshot" on the order-suggestions landing page. No data fetching, so it
 * pre-renders cleanly.
 */
function OrderSuggestionsShowcase({ lang }: OrderSuggestionsShowcaseProps): JSX.Element {
  const t = L[lang];

  return (
    <figure className={styles.showcase} aria-label={t.caption}>
      <div className={styles.window}>
        <div className={styles.toolbar}>
          <div className={styles.dots}>
            <span />
            <span />
            <span />
          </div>
          <span className={styles.advisory}>{t.advisory}</span>
        </div>

        <div className={styles.body}>
          <div className={styles.head}>
            <span className={styles.title}>🛒 {t.title}</span>
            <span className={styles.basis}>{t.basis}</span>
          </div>

          <div className={styles.picker} aria-hidden="true">
            <span className={styles.pickerLabel}>🚚 {t.arrives}</span>
            <span className={styles.pickerValue}>05.07.2026 10:00</span>
          </div>

          <div className={styles.rows}>
            {TANKS.map((tk) => (
              <div
                key={tk.name}
                className={`${styles.row} ${tk.urgent ? styles.rowUrgent : ""}`}
              >
                <div className={styles.meta}>
                  <span className={styles.name}>
                    {tk.urgent && <span className={styles.urgentDot} />}
                    {tk.name}
                    <span className={styles.fuel} style={{ color: tk.color }}>
                      ● {tk.fuel}
                    </span>
                    {tk.urgent && <span className={styles.urgentTag}>{t.urgent}</span>}
                  </span>
                  <span className={styles.projection}>
                    {t.now} {tk.now} → {t.atArrival}{" "}
                    <span className={tk.dry ? styles.dry : ""}>
                      {tk.arrival}
                      {tk.dry && ` · ${t.willRunDry}`}
                    </span>
                  </span>
                </div>
                <span className={styles.order}>
                  {t.order} <strong>{tk.order}</strong>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <figcaption className={styles.caption}>{t.caption}</figcaption>
    </figure>
  );
}

export default OrderSuggestionsShowcase;
